function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import React, { createRef } from 'react';
import Uppy from '@uppy/core';
import ImageEditorPlugin from '@uppy/image-editor';
import ImageEditorConfig from '../UppyUploader/ImageEditorConfig';

var _installPlugin = /*#__PURE__*/_classPrivateFieldLooseKey("installPlugin");

var _uninstallPlugin = /*#__PURE__*/_classPrivateFieldLooseKey("uninstallPlugin");

var ImageEditor = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageEditor, _React$Component);

  var _super = _createSuper(ImageEditor);

  function ImageEditor(props) {
    var _this;

    _classCallCheck(this, ImageEditor);

    _this = _super.call(this, props);
    Object.defineProperty(_assertThisInitialized(_this), _uninstallPlugin, {
      value: _uninstallPlugin2
    });
    Object.defineProperty(_assertThisInitialized(_this), _installPlugin, {
      value: _installPlugin2
    });
    _this.container = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(ImageEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _classPrivateFieldLooseBase(this, _installPlugin)[_installPlugin]();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.uppy !== this.props.uppy) {
        _classPrivateFieldLooseBase(this, _uninstallPlugin)[_uninstallPlugin]();

        _classPrivateFieldLooseBase(this, _installPlugin)[_installPlugin]();
      } else if (prevProps.currentFile !== this.props.currentFile) {
        this.plugin.selectFile(this.props.currentFile);
        this.plugin.cropper.reset();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _classPrivateFieldLooseBase(this, _uninstallPlugin)[_uninstallPlugin]();
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.isVisible ? 'kj-uploader-ImageEditorPanel__container' : 'kj-uploader-ImageEditorPanel__container--hidden';
      return /*#__PURE__*/React.createElement("div", {
        ref: this.container,
        className: className
      });
    }
  }]);

  return ImageEditor;
}(React.Component);

function _installPlugin2() {
  var uppy = this.props.uppy;

  var config = _objectSpread(_objectSpread({}, ImageEditorConfig(this.props)), {}, {
    id: 'react:ImageEditor',
    target: this.container.current
  });

  uppy.use(ImageEditorPlugin, config);
  this.plugin = uppy.getPlugin(config.id);
  this.plugin.selectFile(this.props.currentFile);
}

function _uninstallPlugin2() {
  var uppy = this.props.uppy;
  uppy.removePlugin(this.plugin);
}

ImageEditor.defaultProps = {
  isVisible: true
};
export default ImageEditor;